module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-mobile-411x93.aacaeda5.jpg";